(function ($) {

	// Update cart
	function update_methods(e) {

		if ($(e.target).is('[name="shipping_method_id"][value="location"]')) { // do not update, just open sidebar
			return;
		}

		let url = ghostpress_params.ajax_url + "&action=cart_update_methods",
			data = $(this).serializeArray()

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
	}

	// Zasilkovna pickup point

	function open_zasilkovna_pickup_widget() {
		// Open widget
		Packeta.Widget.pick(
			zasilkovna_widget_params.zasilkovna_api_key,
			zasilkovna_widget_callback,
			{
				"country": $("select[name='shipping_country']").val().toLowerCase(),
				"language": zasilkovna_widget_params.language
			}
		)
	}

	function zasilkovna_widget_callback(locationData) {

		if (locationData != null && typeof locationData !== "undefined") {

			$("input[name='shipping_pickup_point_id']").val(locationData.id);
			$("input[name='shipping_company_name']").val(locationData.place);
			$("input[name='shipping_address_line_1']").val(locationData.street);
			$("input[name='shipping_city']").val(locationData.city);
			$("input[name='shipping_zip']").val(locationData.zip);

			$("form#checkout-methods-form").trigger("change")
			return true;
		}

		return false;
	}

	function balikovna_event_listener(event) {
		if (event.data.message === 'pickerResult') {
			let point = event.data.point;

			$("input[name='shipping_pickup_point_id']").val(point.zip); // point.id has an extra B at start
			$("input[name='shipping_company_name']").val(point.name);
			$("input[name='shipping_address_line_1']").val(point.street);
			// provided zip isn't zip but pickup point id
			let parsed = point.address.match(/.*, ([0-9]{5}), (.*)/); // Vladivostocká 1460/10, Vršovice, 10000, Praha 10
			let zip = parsed[1];
			let city = parsed[2];
			if (!city) {
				city = point.municipality_name;
			}
			if (!zip) {
				zip = point.zip;
			}
			$("input[name='shipping_city']").val(city);
			$("input[name='shipping_zip']").val(zip); // for shipping label is required point.zip not zip from address

			close_balikovna_widget();

			$("form#checkout-methods-form").trigger("change");
		}
	}

	function close_balikovna_widget() {
		$(document).trigger('close_modal')
	}

	function open_balikovna_pickup_widget() {
		$(document).trigger('open_modal', ['checkout-balikovna'])
		window.addEventListener('message', balikovna_event_listener);
	}

	// PPL Parcelshop
	function pplWidgetCallback(locationData) {
		$(".modal-ppl").removeClass("modal--open")

		if (locationData != null && typeof locationData !== "undefined") {
			$("input[name='shipping_pickup_point_id']").val(locationData.code) // for API we need code
			$("input[name='shipping_company_name']").val(locationData.name)
			$("input[name='shipping_address_line_1']").val(locationData.street)
			$("input[name='shipping_city']").val(locationData.city)
			$("input[name='shipping_zip']").val(locationData.zipCode)

			$("form#checkout-methods-form").trigger("change")
			return true
		}

		return false
	}

	function open_ppl_pickup_widget() {
		if (!($('#ppl-parcelshop-map').contents().length)) { // prevent multiple loads if nothing changed
			$("body").append($('<script src="https://www.ppl.cz/sources/map/main.js"></script>'))
		}

		$(".modal-ppl").addClass("modal--open")

		document.addEventListener("ppl-parcelshop-map", (e) => {
			pplWidgetCallback(e.detail)
		})
	}

	function maybe_hide_apple_pay() {

		if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
			let $apple_pay_input = $('input[name="payment_method_id"][value*="apple_pay"]')
			if ($apple_pay_input.is(':checked')) {
				$apple_pay_input.prop('checked', false)
			}

			$apple_pay_input.closest('.checkout-method').hide()
		}
	}

	$(document).gp_ready(function () {

		// Init again fields from AJAX fragments
		$("form#checkout-methods-form").gp_on('change', update_methods)
		$("form#checkout-location-pickup").gp_on('change', function () {
			$(document).trigger('close_modal')
			return update_methods.apply(this, arguments)
		})

		// Pickup points
		$("[data-select-pickup-point]").off("click").click(function () {
			let method_type = $(this).data("select-pickup-point")
			switch (method_type) {
				case 'zasilkovna_pick_up_point':
					open_zasilkovna_pickup_widget()
					break;
				case 'balikovna_pick_up_point':
					open_balikovna_pickup_widget()
					break;
				case 'ppl_parcelshop':
					open_ppl_pickup_widget()
					break;
			}
		})

		maybe_hide_apple_pay()
	})

})(jQuery);